module.exports = __webpack_public_path__ + "static/media/or1019.4b278b25.jpg";